import ContractsMileageTemplateResponse, {
  ContractsMileageTemplateResponseData,
} from "../../../../api/raily/contracts/mileage/template/contracts-mileage-template.response";
import ContractsMileageTemplate from "./contracts-mileage-template";

const createTemplate = (
  item: ContractsMileageTemplateResponseData,
): ContractsMileageTemplate => {
  return {
    dietFullAfterHours: item.dietFullAfterHours,
    dietFullRate: item.dietFullRate,
    dietHalfAfterHours: item.dietHalfAfterHours,
    dietHalfRate: item.dietHalfRate,
    distanceRateCarGt900cm3: item.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: item.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: item.distanceRateCompanyVehicle,
    distanceRateMoped: item.distanceRateMoped,
    distanceRateMotorcycle: item.distanceRateMotorcycle,
  };
};

const create = (
  response: ContractsMileageTemplateResponse,
): ContractsMileageTemplate => {
  return createTemplate(response.data);
};

const contractsMileageTemplateFactory = {
  create,
};

export default contractsMileageTemplateFactory;
